﻿{
  "US": "Соединенные Штаты",
  "AF": "Афганистан",
  "AX": "Аландские острова",
  "AL": "Албания",
  "DZ": "Алжир",
  "AS": "Американское (Восточное) Самоа",
  "AD": "Андорра",
  "AO": "Ангола",
  "AI": "Ангилья",
  "AQ": "Антарктида",
  "AG": "Антигуа и Барбуда",
  "AR": "Аргентина",
  "AM": "Армения",
  "AW": "Аруба",
  "AU": "Австралия",
  "AT": "Австрия",
  "AZ": "Азербайджан",
  "BS": "Багамские острова",
  "BH": "Бахрейн",
  "BD": "Бангладеш",
  "BB": "Барбадос",
  "BY": "Беларусь",
  "BE": "Бельгия",
  "BZ": "Белиз",
  "BJ": "Бенин",
  "BM": "Бермуды",
  "BT": "Бутан",
  "BO": "Боливия",
  "BA": "Босния и Герцеговина",
  "BW": "Ботсвана",
  "BV": "Остров Буве",
  "BR": "Бразилия",
  "IO": "Британская Территория в Индийском Океане",
  "BN": "Бруней-Даруссалам",
  "BG": "Болгария",
  "BF": "Буркина-Фасо",
  "BI": "Бурунди",
  "KH": "Камбоджа",
  "CM": "Камерун",
  "CA": "Канада",
  "CV": "Кабо-Верде",
  "KY": "Каймановы острова",
  "CF": "Центральноафриканская Республика",
  "TD": "Чад",
  "CL": "Чили",
  "CN": "Китай",
  "CX": "Остров Рождества",
  "CC": "Кокосовые острова (острова Килинг)",
  "CO": "Колумбия",
  "KM": "Коморские острова",
  "CG": "Конго",
  "CD": "Конго, Демократическая Республика",
  "CK": "Острова Кука",
  "CR": "Коста-Рика",
  "CI": "Кот-д'Ивуар",
  "HR": "Хорватия",
  "CU": "Куба",
  "CY": "Кипр",
  "CZ": "Чешская Республика",
  "DK": "Дания",
  "DJ": "Джибути",
  "DM": "Доминика",
  "DO": "Доминиканская республика",
  "EC": "Эквадор",
  "EG": "Египет",
  "SV": "Сальвадор",
  "GQ": "Экваториальная Гвинея",
  "ER": "Эритрея",
  "EE": "Эстония",
  "ET": "Эфиопия",
  "FK": "Фолклендские (Мальвинские) острова",
  "FO": "Фарерские острова",
  "FJ": "Фиджи",
  "FI": "Финляндия",
  "FR": "Франция",
  "GF": "Французская Гвиана",
  "PF": "Французская Полинезия",
  "TF": "Французские Южные Территории",
  "GA": "Габон",
  "GM": "Гамбия",
  "GE": "Грузия",
  "DE": "Германия",
  "GH": "Гана",
  "GI": "Гибралтар",
  "GR": "Греция",
  "GL": "Гренландия",
  "GD": "Гренада",
  "GP": "Гваделупа",
  "GU": "Гуам",
  "GT": "Гватемала",
  "GG": "Гернси",
  "GN": "Гвинея",
  "GW": "Гвинея-Биссау",
  "GY": "Гайана",
  "HT": "Гаити",
  "HM": "Остров Херд и острова Макдональда",
  "VA": "Святой Престол (Государство-город Ватикан)",
  "HN": "Гондурас",
  "HK": "Гонконг",
  "HU": "Венгрия",
  "IS": "Исландия",
  "IN": "Индия",
  "ID": "Индонезия",
  "IR": "Иран, Исламская Республика",
  "IQ": "Ирак",
  "IE": "Ирландия",
  "IM": "Остров Мэн",
  "IL": "Израиль",
  "IT": "Италия",
  "JM": "Ямайка",
  "JP": "Япония",
  "JE": "Джерси",
  "JO": "Иордания",
  "KZ": "Казахстан",
  "KE": "Кения",
  "KI": "Кирибати",
  "KR": "Корея",
  "KW": "Кувейт",
  "KG": "Кыргызстан",
  "LA": "Лаосская Народно-Демократическая Республика",
  "LV": "Латвия",
  "LB": "Ливан",
  "LS": "Лесото",
  "LR": "Либерия",
  "LY": "Ливийская Арабская Джамахирия",
  "LI": "Лихтенштейн",
  "LT": "Литва",
  "LU": "Люксембург",
  "MO": "Макао",
  "MK": "Македония",
  "MG": "Мадагаскар",
  "MW": "Малави",
  "MY": "Малайзия",
  "MV": "Мальдивы",
  "ML": "Мали",
  "MT": "Мальта",
  "MH": "Маршалловы Острова",
  "MQ": "Мартиника",
  "MR": "Мавритания",
  "MU": "Маврикий",
  "YT": "Майотта",
  "MX": "Мексика",
  "FM": "Микронезия, Федеративные Штаты",
  "MD": "Молдова",
  "MC": "Монако",
  "MN": "Монголия",
  "ME": "Черногория",
  "MS": "Монтсеррат",
  "MA": "Марокко",
  "MZ": "Мозамбик",
  "MM": "Мьянма",
  "NA": "Намибия",
  "NR": "Науру",
  "NP": "Непал",
  "NL": "Нидерланды",
  "AN": "Нидерландские Антильские острова",
  "NC": "Новая Каледония",
  "NZ": "Новая Зеландия",
  "NI": "Никарагуа",
  "NE": "Нигер",
  "NG": "Нигерия",
  "NU": "Ниуэ",
  "NF": "Остров Норфолк",
  "MP": "Северные Марианские Острова",
  "NO": "Норвегия",
  "OM": "Оман",
  "PK": "Пакистан",
  "PW": "Палау",
  "PS": "Палестинская территория, Оккупированная",
  "PA": "Панама",
  "PG": "Папуа - Новая Гвинея",
  "PY": "Парагвай",
  "PE": "Перу",
  "PH": "Филиппины",
  "PN": "Питкэрн",
  "PL": "Польша",
  "PT": "Португалия",
  "PR": "Пуэрто-Рико",
  "QA": "Катар",
  "RE": "Реюньон",
  "RO": "Румыния",
  "RU": "Российская Федерация",
  "RW": "Руанда",
  "BL": "Сен-Бартелеми",
  "SH": "остров Святой Елены",
  "KN": "Сент-Китс и Невис",
  "LC": "Сент-Люсия",
  "MF": "Сен-Мартен",
  "PM": "Сен-Пьер и Микелон",
  "VC": "Сент-Винсент и Гренадины",
  "WS": "Самоа",
  "SM": "Сан-Марино",
  "ST": "Сан-Томе и Принсипи",
  "SA": "Саудовская Аравия",
  "SN": "Сенегал",
  "RS": "Сербия",
  "SC": "Сейшельские Острова",
  "SL": "Сьерра-Леоне",
  "SG": "Сингапур",
  "SK": "Словакия",
  "SI": "Словения",
  "SB": "Соломоновы острова",
  "SO": "Сомали",
  "ZA": "Южная Африка",
  "GS": "Южная Георгия и Южные Сандвичевы Острова",
  "ES": "Испания",
  "LK": "Шри-Ланка",
  "SD": "Судан",
  "SR": "Суринам",
  "SJ": "Шпицберген и Ян-Майен",
  "SZ": "Свазиленд",
  "SE": "Швеция",
  "CH": "Швейцария",
  "SY": "Сирийская Арабская Республика",
  "TW": "Тайвань",
  "TJ": "Таджикистан",
  "TZ": "Танзания",
  "TH": "Таиланд",
  "TL": "Тимор-Лесте",
  "TG": "Того",
  "TK": "Токелау",
  "TO": "Тонга",
  "TT": "Тринидад и Тобаго",
  "TN": "Тунис",
  "TR": "Турция",
  "TM": "Туркменистан",
  "TC": "Острова Теркс и Кайкос",
  "TV": "Тувалу",
  "UG": "Уганда",
  "UA": "Украина",
  "AE": "Объединенные Арабские Эмираты",
  "GB": "Великобритания",
  "UM": "Внешние малые острова США",
  "UY": "Уругвай",
  "UZ": "Узбекистан",
  "VU": "Вануату",
  "VE": "Венесуэла",
  "VN": "Вьетнам",
  "VG": "Виргинские острова, Британские",
  "VI": "Виргинские острова, Американские",
  "WF": "Уоллис и Футуна",
  "EH": "Западная Сахара",
  "YE": "Йемен",
  "ZM": "Замбия",
  "ZW": "Зимбабве"
}
